export default __webpack_public_path__ + "static/media/user.808c4622.svg";